var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "reports"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29289",
    "data-name": "Rectangle 29289",
    width: 16,
    height: 16,
    transform: "translate(26 492)",
    fill: "#8391a2",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_685",
    "data-name": "Mask Group 685",
    transform: "translate(-26 -492)",
    clipPath: "url(#reports)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_-_2022-04-27T100956.040",
    "data-name": "svgexport-6 - 2022-04-27T100956.040",
    transform: "translate(26 492)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11632",
    "data-name": "Path 11632",
    d: "M7.812,5.625A.313.313,0,1,0,7.5,5.312.313.313,0,0,0,7.812,5.625Zm0,0",
    fill: "#8391a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11633",
    "data-name": "Path 11633",
    d: "M7.812,6.875A.313.313,0,1,0,7.5,6.562.313.313,0,0,0,7.812,6.875Zm0,0",
    fill: "#8391a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11634",
    "data-name": "Path 11634",
    d: "M15.908,3.217,12.783.092A.316.316,0,0,0,12.562,0H4.687A.939.939,0,0,0,3.75.938v.952c-.1-.009-.208-.014-.312-.014a3.437,3.437,0,0,0,0,6.875c.1,0,.209-.005.313-.014v6.327A.939.939,0,0,0,4.687,16H15.062A.939.939,0,0,0,16,15.063V3.438a.314.314,0,0,0-.092-.221Zm-3.033-2.15,2.058,2.058H12.875ZM3.75,2.517A2.817,2.817,0,0,1,6.232,5H3.75ZM.625,5.313a2.816,2.816,0,0,1,2.5-2.8v2.8a.312.312,0,0,0,.313.312H6.232A2.812,2.812,0,0,1,.625,5.313ZM15.062,15.375H4.687a.313.313,0,0,1-.312-.312V8.62a3.438,3.438,0,0,0,0-6.615V.938A.313.313,0,0,1,4.687.625H12.25V3.438a.312.312,0,0,0,.313.313h2.813V15.063a.313.313,0,0,1-.312.313Zm0,0",
    fill: "#8391a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11635",
    "data-name": "Path 11635",
    d: "M8,2.5h3.312a.313.313,0,0,0,0-.625H8A.313.313,0,0,0,8,2.5Zm0,0",
    fill: "#8391a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11636",
    "data-name": "Path 11636",
    d: "M8,3.75h3.312a.313.313,0,0,0,0-.625H8A.313.313,0,0,0,8,3.75Zm0,0",
    fill: "#8391a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11637",
    "data-name": "Path 11637",
    d: "M3.437,6.875A1.564,1.564,0,0,1,1.875,5.312a.312.312,0,1,0-.625,0A2.19,2.19,0,0,0,3.437,7.5a.313.313,0,0,0,0-.625Zm0,0",
    fill: "#8391a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11638",
    "data-name": "Path 11638",
    d: "M13.719,8.312a.937.937,0,0,0-.777,1.461L10.771,12.1a.939.939,0,0,0-.648.039L9.146,10.93a.938.938,0,1,0-1.675-.016l-1.14,1.235a.938.938,0,1,0,.447.437l1.14-1.235a.94.94,0,0,0,.771.008l.977,1.212a.938.938,0,1,0,1.611-.094l2.17-2.329a.937.937,0,1,0,.271-1.835Zm-7.781,5A.313.313,0,1,1,6.25,13,.313.313,0,0,1,5.937,13.312ZM8,10.5a.313.313,0,1,1,.313.313A.313.313,0,0,1,8,10.5Zm2.5,2.812A.313.313,0,1,1,10.812,13,.313.313,0,0,1,10.5,13.312Zm3.219-3.75a.313.313,0,1,1,.313-.312A.313.313,0,0,1,13.719,9.562Zm0,0",
    fill: "#8391a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11639",
    "data-name": "Path 11639",
    d: "M8.75,5.312a.312.312,0,0,0,.313.313h4.75a.313.313,0,0,0,0-.625H9.062A.312.312,0,0,0,8.75,5.312Zm0,0",
    fill: "#8391a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11640",
    "data-name": "Path 11640",
    d: "M13.812,6.25H9.062a.313.313,0,0,0,0,.625h4.75a.313.313,0,0,0,0-.625Zm0,0",
    fill: "#8391a2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.f7eaf155bf171d2f9d5c1b02b98e8e90.svg";
export { ForwardRef as ReactComponent };